import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getLocaleConverted } from '../../helpers';

@Injectable()
export class LocaleInterceptor implements HttpInterceptor {
  /**
   * Convert Object to HttpParams
   * @param {Object} obj
   * @returns {HttpParams}
   */
  toHttpParams(obj: Record<string, string>): HttpParams {
    return Object.entries(obj).reduce(
      (params, [key, value]) => params.set(key, value),
      new HttpParams()
    );
  }

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const postData: Record<string, string> = {};
    postData['locale'] = getLocaleConverted(navigator.language);
    if (
      req.url.indexOf('assets') !== -1 ||
      req.url.indexOf('tables') !== -1 ||
      req.method === 'POST'
    ) {
      return next.handle(req);
    }
    // Clone the request to add the new header with locale parameter for languages
    const params = this.toHttpParams(postData);

    req = req.clone({
      params: params,
    });

    // Pass the cloned request instead of the original request to the next handle
    return next.handle(req);
  }
}
